import { businessConstants } from './business.constants';

export const DefaultEntityTemplateConfiguration = JSON.parse(`
{
  "noteType": {
    "id": ${`"${businessConstants.EntryTypes.Tamale_Note_Id}"`},
    "name": "TamaleNote"
  },
  "width": "527",
  "contains": [
    [
      {
        "isLabelHidden": false,
        "isHidden": false,
        "labelWidth": "80",
        "heigh": "26",
        "width": "527",
        "label": "Name:        ",
        "controlID": "NAME",
        "TypeName": "LayoutControlItem",
        "componentType": "name-input"
      }
    ],
    [
      {
        "isLabelHidden": false,
        "isHidden": false,
        "labelWidth": "80",
        "heigh": "26",
        "width": "527",
        "label": "Shortname:        ",
        "controlID": "SHORTNAME",
        "TypeName": "LayoutControlItem",
        "componentType": "shortname-input"
      }
    ]
  ],
  "entityTypeId": ${`"${businessConstants.EntityTypes.Corporate_Id}"`},
  "isDefaultConfig": true
}
`);
